import React from "react";

const Footer = () => {
    return (
        // Footer section: shared legal/brand text for all protected pages.
        <footer className="border-t border-white/70 bg-white/80 px-6 py-4 text-center text-sm text-slate-500">
            (c) 2026 PG Admin Panel. All Rights Reserved.
        </footer>
    );
};

export default Footer;
